import script from "./PSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./PSearch.vue?vue&type=script&lang=ts&setup=true"

import "./PSearch.vue?vue&type=style&index=0&id=325e9cc3&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325e9cc3"]])

export default __exports__